import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class QcDashboardDataService {
  apiEP: string = window.apiUrl;
  constructor(private http: HttpClient) {}

  getCompanies(ticker) {
    return this.http.get(`${this.apiEP}/api/analystheaderdata/${ticker}`);
  }
  getConsensusTemplateData(ticker: string): Observable<any> {
    return this.http.get(`${this.apiEP}/api/consensustemplatedata/${ticker}/`);
  }
}
